import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Button from "material-ui/Button";
import PropTypes from "prop-types";
import history from "utils/history";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const styles = {
  wrapper: {
    flex: 1
  },
  btn: {
    marginLeft: 10,
    verticalAlign: "-webkit-baseline-middle"
  }
};

const BackButton = props =>
  window.history.length > 1 && (
    <div className={props.classes.wrapper}>
      <Button
        dense
        raised={props.raised}
        onClick={() => props.handleClick(props.link)}
        className={classnames(props.classes.btn, props.className)}
      >
        戻る
      </Button>
    </div>
  );

BackButton.propTypes = {
  link: PropTypes.string
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClick: link => {
    if (link) {
      history.push(link, ownProps);
    } else {
      ownProps.history.goBack();
    }
  }
});

export default withRouter(
  connect(state => state, mapDispatchToProps)(withStyles(styles)(BackButton))
);



// WEBPACK FOOTER //
// ./src/components/BackButton.jsx